/* eslint-disable max-len */
import React from "react";
import { func } from "prop-types";
import moment from "moment";

import Modal from "Main/components/layouts/modals/Modal";
import { isDateExpired } from 'Core/helpers/date';
import { useUserConsultations } from "../../hooks/useUserConsultations";

export default function PaymentModal({ closeModal }) {
  const { isLoading, consultations } = useUserConsultations();

  if (isLoading) {
    return <></>;
  }

  const { expirationsDate, monthPrice } = consultations;

  const nextMonth = isDateExpired(expirationsDate) ? new Date() : new Date(expirationsDate);
  nextMonth.setMonth(nextMonth.getMonth() + 1);

  return (
    <Modal closeModal={closeModal} showCross showTimes>
      <div className="extend_consultation">
        <div className="extend_consultation_info">
          <h2>Продлить консультации</h2>
          <img src="/images/chat/extend_consultations_cat.png" alt="" />
          <p>
            В консультации входит возможность сдавать домашние работы и получать
            по ним обратную связь. После оплаты необходимо нажать на кнопку &quot;Вернуться в магазин&quot;.
          </p>
        </div>
        <div className="extend_consultation_tariffs">
          <div className="extend_consultation_tariff">
            <h3>1 месяц</h3>
            <p>
              Единоразовая оплата. Консультации и возможность загрузки
              домашних работ будут продлены до
              {' '}
              {moment(nextMonth).format("D MMMM YYYY")}
              {' '}
              года.
            </p>
            <div className="extend_consultation_price">
              <p>
                {monthPrice}
                {' '}
                ₽
              </p>
              <div className="extend_consultation_button">
                <a
                  href="/payment/robokassa/consultations?period=month"
                >
                  Оплатить
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

PaymentModal.propTypes = {
  closeModal: func.isRequired,
};
